export default __webpack_public_path__ + "static/media/big-med-pdf.a5fa5172.jpg";